export default "__VITE_ASSET__BOxxUx2z__"